module.exports = __webpack_public_path__ + "assets/2b62fea5008934aafda53a126bc03d34.mp3";